import { useEffect } from "react";
import { setFeatures } from "../functions/drawer.map.js";
import {
  CAMPUS_COLLECTION,
  POI_NODES,
  POI_POLYGONS,
} from "../../../../reduxStore/actions/main.js";
import { map } from "./useMap.sideEffects.js";
import { easeToFeature } from "../functions/interactivity.map.js";
import { bbox, featureCollection } from "@turf/turf";
import { sourceIds } from "../variables/sourceIds.js";

/**
 * Initialisierung und rendering der Features
 */
export default function useFeatures(props) {
  const setLoadedFeatures = () => {
    if (!(props.serverDataLoaded && props.mapLoaded)) return;

    // Rendern der Features auf der Map
    // Nodes
    const currentCampus = CAMPUS_COLLECTION.getCurrentCampus();
    const currentLevel = CAMPUS_COLLECTION.getLevelByIndex(
      props.currentFloorIndex
    );
    const showOutdoor = currentCampus.showOutdoorEinrichtungenOnMap;

    const nodesWithPOIs = [];
    const nodesWithRooms = [];
    const nodesWithAdresses = [];
    const nodesWithIcons = [];

    // für eine optimale performance müssen je nach source die
    // features im vorfeld richtig gefiltert sein
    // console.log("campusId", props.currentCampusId);

    // console.log("ICH SCHAU MIR ALLE MEINE POIS AND!!!!", POI_NODES);

    POI_NODES.forEach((p) => {
      // if (p.properties.iconname === "taxi") {
      //   console.log(
      //     "Das ist mein Taxistand und ich bin in der useFeatures scheisse",
      //     p
      //   );
      // }

      if (
        p.properties.campusId === props.currentCampusId &&
        p.properties.type !== "Gebäude"
      ) {
        if (p.properties.type === "Raum") {
          if (p.properties.level === currentLevel) {
            nodesWithRooms.push(p);
          }
        } else {
          if (p.properties.iconname && p.properties.level === currentLevel) {
            nodesWithIcons.push(p);
          }
          if (
            (p.properties.type === "Einrichtung" ||
              p.properties.type === "POI" ||
              p.properties.type === "Adresse" ||
              !p.properties.iconname) &&
            p.properties.level === currentLevel
          ) {
            if (!showOutdoor && p.properties.indoors) {
              nodesWithPOIs.push(p);
            } else if (showOutdoor) {
              nodesWithPOIs.push(p);
            }
          }

          if (
            p.properties.type === "Adresse" &&
            p.properties.additionalData?.class &&
            !p.properties.indoors
          ) {
            nodesWithAdresses.push(p);
          }
        }
      }
    });
    // console.log({
    //   POI_NODES,
    //   poinodeslength: POI_NODES?.length,
    //   nodesWithIcons,
    //   nodesWithAdresses,
    //   nodesWithPOIs,
    //   nodesWithRooms,
    //   POI_POLYGONS,
    // });
    setFeatures({
      map: map,
      features: nodesWithIcons,
      sourceId: sourceIds.iconNodes,
    });
    setFeatures({
      map: map,
      features: nodesWithAdresses,
      sourceId: sourceIds.addressNodes,
    });
    setFeatures({
      map: map,
      features: nodesWithPOIs.sort((a, b) => {
        if (a.properties.type === "Adresse") return -1;
        if (b.properties.type === "Adresse") return 1;
        if (a.properties.type === "Stockwerk") return 1;
        if (b.properties.type === "Stockwerk") return -1;
        return 0;
      }),
      sourceId: sourceIds.nodes,
    });
    setFeatures({
      map: map,
      features: nodesWithRooms,
      sourceId: sourceIds.roomNodes,
    });

    // Polygons
    setFeatures({
      map: map,
      features: POI_POLYGONS,
      sourceId: sourceIds.polygons,
    });
  };
  const setFeatureChildren = () => {
    if (!props.mapLoaded) return;

    // Zeigt currentChildren an, falls das ausgewählte Feature selbst keinen Standort hat, aber
    // seine Kinder welche haben
    // Hier werden die Features für Kinder gesetzt.
    // setFeatures({
    //   sourceId: sourceIds.poiChildren,
    //   features: props.currentChildrenFeatures,
    // });

    // wenn keine Kinder ausgewählt sind -> no action, logisch
    // wenn ein Feature aber auch eine Location hat heißst das, dass eines der Kinder ausgewählt wurde!
    // also normaler Feature Zoom und kein weit rauszoomen um alle children zu sehen!
    if (!props.currentChildrenFeatures || props.currentFeature.hasLocation())
      return;

    // bei jedem change der current Children müssen die mapbounds gesetzt werden!
    if (props.currentChildrenFeatures?.length > 1) {
      let childrenBounding = bbox(
        featureCollection(props.currentChildrenFeatures)
      );
      easeToFeature(childrenBounding, {
        padding: props.mapPadding,
      });
    } else if (props.currentChildrenFeatures?.length === 1) {
      easeToFeature(props.currentChildrenFeatures[0], {
        padding: props.mapPadding,
      });
    }
  };

  useEffect(setLoadedFeatures, [
    props.serverDataLoaded,
    props.mapLoaded,
    props.currentCampusId,
    props.currentFloorIndex,
  ]);

  /**
   * Rendert alle Children, wenn ein POI selected wird, der keinen Standort hat
   */
  useEffect(setFeatureChildren, [
    props.mapLoaded,
    props.currentChildrenFeatures,
    props.mapPadding,
  ]);
}
